import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { TProduct } from 'modules/ProductManagement/reducers/type';
import { ElementContainer } from '../../style';
import { getFirstElementInProductList } from '../../reducers/accessors';

const BusinessName: React.FC = () => {
    const { businessName } = useSelector<RootState, TProduct>(getFirstElementInProductList);
    return (
        <ElementContainer>
            <h6>Business Name</h6>
            <span data-testid="businessName">{businessName}</span>
        </ElementContainer>
    );
};

export default BusinessName;
